import { resolveApiBaseUrl } from '../utils/apiBase';
import { ensureCsrfCookie, xsrfHeaders } from './authApi';

const API = () => resolveApiBaseUrl();

async function publicJsonFetch(path) {
  const response = await fetch(`${API()}${path}`, {
    headers: { Accept: 'application/json' },
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.message || `Request failed (${response.status})`);
  }
  return response.json();
}

export async function listAuthors({ q, page = 0, size = 20 } = {}) {
  const params = new URLSearchParams({ page: String(page), size: String(size) });
  if (q) params.set('q', q);
  return publicJsonFetch(`/authors?${params}`);
}

export async function getAuthorProfile(slug) {
  return publicJsonFetch(`/authors/${encodeURIComponent(slug)}`);
}

export async function getAuthorArticles(slug, page = 0, size = 20) {
  const params = new URLSearchParams({ page: String(page), size: String(size) });
  return publicJsonFetch(`/authors/${encodeURIComponent(slug)}/articles?${params}`);
}

export async function getAuthorArticle(slug, articleId) {
  return publicJsonFetch(
    `/authors/${encodeURIComponent(slug)}/articles/${encodeURIComponent(articleId)}`
  );
}

export function authorFeedUrl(slug) {
  return `${API()}/authors/${encodeURIComponent(slug)}/feed.xml`;
}

export async function getAuthorFollowStatus(slug) {
  await ensureCsrfCookie();
  const response = await fetch(`${API()}/authors/${encodeURIComponent(slug)}/follow-status`, {
    credentials: 'include',
    headers: { Accept: 'application/json', ...xsrfHeaders() },
  });
  if (!response.ok) {
    return { following: false };
  }
  return response.json();
}

export async function followAuthor(slug) {
  return jsonFetchAuth(`/authors/${encodeURIComponent(slug)}/follow`, { method: 'POST' });
}

export async function unfollowAuthor(slug) {
  return jsonFetchAuth(`/authors/${encodeURIComponent(slug)}/follow`, { method: 'DELETE' });
}

export async function listFollowing() {
  return jsonFetchAuth('/me/following');
}

export async function getMyAuthorProfile() {
  await ensureCsrfCookie();
  const response = await fetch(`${API()}/research/author-profile`, {
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      ...xsrfHeaders(),
    },
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.message || `Request failed (${response.status})`);
  }
  return response.json();
}

export async function updateMyAuthorProfile({ displayName, authorSlug, bio }) {
  return jsonFetchAuth('/research/author-profile', {
    method: 'PUT',
    body: JSON.stringify({
      ...(displayName !== undefined ? { displayName } : {}),
      ...(authorSlug !== undefined ? { authorSlug } : {}),
      ...(bio !== undefined ? { bio } : {}),
    }),
  });
}

async function jsonFetchAuth(path, options = {}) {
  await ensureCsrfCookie();
  const response = await fetch(`${API()}${path}`, {
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      ...xsrfHeaders(),
      ...(options.body ? { 'Content-Type': 'application/json' } : {}),
      ...options.headers,
    },
    ...options,
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.message || `Request failed (${response.status})`);
  }
  if (response.status === 204) {
    return null;
  }
  return response.json();
}
